export const tileBorderBottomStyle = `border-bottom: 1px solid ${Styles.color.grey.four};`;
export const MOBILE_TILE_BACKGROUND_COLOR = Styles.color.white;
export const SHARED_LIST_BORDER_BOTTOM_COLOR = Styles.color.grey.five;
const GRID_COLUMNS = 'repeat(3, minmax(212px, 368px))';
export const MENU_LIST_GRID_TEMPLATE_COLUMNS_ON_MAIN_MENU = GRID_COLUMNS;
export const MENU_LIST_GRID_TEMPLATE_COLUMNS = GRID_COLUMNS;
export const DESKTOP_TILE_IMAGE_HEIGHT = '15rem';
